import {kebabCase} from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getHeaders = (guide) => {
  const headers = [];
  if (guide.intro) {
    headers.push({
      name: 'Overview',
      slug: 'overview',
    });
  }

  if (guide.stages) {
    headers.push({
      name: 'Interview Process',
      slug: 'interview-process',
    });
  }

  if (guide.questions) {
    headers.push({
      name: 'Sample Questions',
      slug: 'sample-interview-questions',
    });
  }

  if (guide.evaluation) {
    headers.push({
      name: 'Hiring Decision',
      slug: 'hiring-decision',
    });
  }

  (guide.additionalContent || [])
    .forEach((content) => {
      headers.push({
        name: content.name,
        slug: kebabCase(content.name),
      });
    });

  if (guide.faq && guide.faq.length > 0) {
    headers.push({
      name: 'FAQ',
      slug: 'faq',
    });
  }

  return headers;
};
